import { joinPath } from '@/libs/react-router';

const ROOT_PATH = '/auth';
const SIGN_IN_PATH = joinPath(ROOT_PATH, 'sign-in');

export const AuthPaths = {
  ROOT_PATH,
  SIGN_IN_PATH,
} as const;
